import { Fragment, useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Header from "./Header";
import Navbar from "./Navbar";
import Body from "./Body";
import Footer from "./Footer";
import Main from "./layout/login/Main";
import Landing from "./layout/landing";
import PrivacyPolicy from "./layout/privacyPolicy";
import TermsOfService from "./layout/privacyPolicy/termsofservice";
import About from "./layout/about";
import { Tooltip } from "react-tooltip";
import { Helmet } from "react-helmet";
import AuthorizeRedirect from "./layout/shop/authorizeRedirect";
import { getExchangeRate } from "actions/websiteActions";
import { setCookie, getCookie } from "./Function";
import Swal from "sweetalert2";

function Maincontainer(props) {
    var { getExchangeRate, setCookie, getCookie } = props;
    var { isAuthenticated, user } = props.user;
    const [toggleSidebar, setToggleSidebar] = useState(false);
    // Swal.fire("Error", "Maintaince server.We will be back at 2am on 10/21/2025", "error");
    const fetchExchangeRate = useCallback(async () => {
        try {
            await getExchangeRate("USD").then((v) => {
                setCookie("cotik_exchange_rate", v, 1);
                localStorage.setItem("cotik_currency_to", "USD");
                localStorage.setItem("cotik_symbol_to", "$");
            });
        } catch (err) {
            console.error("Fetch Exchange Rate failed:", err);
        }
    }, []);

    useEffect(() => {
		if (!getCookie("cotik_exchange_rate")) {
            fetchExchangeRate();
        }
    }, []);

    const htmlAdmin = () => (
        <Fragment>
            <Helmet>
                <title>{window.location.pathname.indexOf("/app") < 0 ? "CoTik" : "COTIK"}</title>
            </Helmet>
            <div
                id="kt_body"
                className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed toolbar-tablet-and-mobile-fixed aside-enabled aside-fixed"
                style={{ "--kt-toolbar-height": "55px", "--kt-toolbar-height-tablet-and-mobile": "55px" }}
                data-kt-aside-minimize={toggleSidebar ? "on" : ""}
            >
                {isAuthenticated ? (
                    <Fragment>
                        <div className="page d-flex flex-row flex-column-fluid vh-100">
                            <Navbar toggleSidebar={toggleSidebar} setToggleSidebar={setToggleSidebar} />
                            <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                                <Header toggleSidebar={toggleSidebar} setToggleSidebar={setToggleSidebar} />
                                <Body />
                                <Footer />
                            </div>
                        </div>
                    </Fragment>
                ) : (
                    <div className="d-flex flex-column flex-root vh-100">
                        <Main />
                    </div>
                )}
            </div>
            <Tooltip id="my-tooltip" />
        </Fragment>
    );

    return (
        <Router>
            <Routes>
                <Route path="/admin/*" element={htmlAdmin()} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/about" element={<About />} />
                <Route path="/shops/authorize/:name" element={<AuthorizeRedirect />} />
                <Route path="/shops-message/authorize/:name" element={<AuthorizeRedirect />} />
                <Route path="/shops-promotion/authorize/:name" element={<AuthorizeRedirect />} />
                <Route
                    path="/*"
                    element={
                        <Landing />
                    }
                />
            </Routes>
        </Router>
    );
}

Maincontainer.propTypes = {
	getExchangeRate: PropTypes.func.isRequired,
	setCookie: PropTypes.func.isRequired,
	getCookie: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = {
    getExchangeRate,
    setCookie,
    getCookie,
};

export default connect(mapStateToProps, mapDispatchToProps)(Maincontainer);
